import dayjs from '@/js/libs/dayjs';
import { DATE_RANGE_SEPARATOR } from './constants';
export const isDefinedDateRange = (value) => value?.[0] instanceof Date && value?.[1] instanceof Date;
export const getValidDateRange = ({ value, dateFormatKey, showLocal, minDate, maxDate }) => {
    const [start, end] = value.split(DATE_RANGE_SEPARATOR).map((part) => part.trim());
    const startDate = dayjs(start, dateFormatKey, true);
    const endDate = dayjs(end, dateFormatKey, true);
    const min = dayjs(minDate).startOf('day');
    const max = dayjs(maxDate).startOf('day');
    const isValidDates = startDate.isValid() &&
        endDate.isValid() &&
        startDate.isSameOrBefore(endDate) &&
        (minDate ? startDate.isSameOrAfter(min) && endDate.isSameOrAfter(min) : true) &&
        (maxDate ? startDate.isSameOrBefore(max) && endDate.isSameOrBefore(max) : true);
    if (isValidDates) {
        return showLocal ? [startDate.local().toDate(), endDate.local().toDate()] : [startDate.utc(true).toDate(), endDate.utc(true).toDate()];
    }
    return null;
};
export const getValidDate = ({ value, dateFormatKey, showLocal, minDate, maxDate }) => {
    if (!value)
        return null;
    const date = dayjs(value, dateFormatKey, true);
    const min = dayjs(minDate).startOf('day');
    const max = dayjs(maxDate).startOf('day');
    if (date.isValid() && (minDate ? date.isSameOrAfter(min) : true) && (maxDate ? date.isSameOrBefore(max) : true)) {
        return showLocal ? date.local().toDate() : date.utc(true).toDate();
    }
    return null;
};
export const generateTimePresets = (intervals) => {
    const presets = [];
    const startTime = dayjs().startOf('day');
    const endTime = dayjs().endOf('day');
    for (let currentTime = startTime; currentTime.isBefore(endTime); currentTime = currentTime.add(intervals, 'minute')) {
        const preset = {
            title: currentTime.format('HH:mm'),
            value: currentTime.toDate(),
            isActive: (selected, current) => {
                if (!selected)
                    return false;
                const selectedDate = dayjs(selected);
                const currentDate = dayjs(current);
                return selectedDate.hour() === currentDate.hour() && selectedDate.minute() === currentDate.minute();
            },
        };
        presets.push(preset);
    }
    return presets;
};
export const getDateArray = (value, showLocal) => {
    if (Array.isArray(value)) {
        const startDate = dayjs(value[0]).startOf('day');
        const endDate = dayjs(value[1]).startOf('day');
        const formattedStartDate = showLocal ? startDate.local() : startDate.utc(true);
        const formattedEndDate = showLocal ? endDate.local() : endDate.utc(true);
        return [
            formattedStartDate.isValid() ? formattedStartDate.toDate() : null,
            formattedEndDate.isValid() ? formattedEndDate.toDate() : null,
        ];
    }
    return [null, null];
};
